import { render, staticRenderFns } from "./LmBtnUpdateContentGeneric.vue?vue&type=template&id=7fb8d233&scoped=true&"
var script = {}
import style0 from "./LmBtnUpdateContentGeneric.vue?vue&type=style&index=0&id=7fb8d233&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb8d233",
  null
  
)

export default component.exports